import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueScrollTo from 'vue-scrollto'
import Braze from '@/plugins/braze.js'
import Amplitude from '@/plugins/amplitude.js'
import useApi from '@/composition/api'
import { i18n, setI18nLanguage } from './i18n'
import '@frontend/simple-billing/dist/style.css'

const api = useApi()
const app = createApp(App).use(router).use(store).use(Braze).use(Amplitude, { store }).use(i18n)

app.directive('scroll-to', VueScrollTo, { duration: 1000 })

// app.config.errorHandler = (err) => {
// 	document.getElementById('log').innerHTML += '<br/>' + err
// }

app.mount('#app')

window.onload = () => {
	api.init()
	setI18nLanguage(api.getLanguage())
}
//
